<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">

                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">{{$t('member_payment')}}</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <!-- <a href="#!" class="btn btn-sm btn-primary">Settings</a> -->
                                </div>
                            </div>
                        </div>
                        <template>
                            <ValidationObserver v-slot="{ passes }">
                            <form @submit.prevent="passes(onSubmit)">
                                <h6 class="heading-small text-muted mb-4">{{$t('member_type')}} <span style="color:red">*</span></h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-radio name="onetime" class="mb-3" v-model="form.type">
                                                {{$t('onetime')}}
                                            </base-radio>
                                            <base-radio name="weekly" class="mb-3" v-model="form.type">
                                                {{$t('weekly')}}
                                            </base-radio>
                                            <base-radio name="monthly" class="mb-3" v-model="form.type">
                                                {{$t('monthly')}}
                                            </base-radio>
                                            <base-radio name="yearly" class="mb-3" v-model="form.type">
                                                {{$t('yearly')}}
                                            </base-radio>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">{{$t('payment_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input :name="$t('amount_payment')" class="input-group-alternative mb-3"
                                                        required
                                                        :label="$t('amount_payment')"
                                                        rules="required"
                                                        type="number"
                                                        :placeholder="$t('amount_payment')"
                                                        v-model="form.amount">
                                            </base-input>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <h6 class="heading-small text-muted mb-4">{{$t('more_information')}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input :name="$t('note')" class="input-group-alternative mb-3"
                                                        :placeholder="$t('note')"
                                                        v-model="form.note">
                                            </base-input>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="text-right">
                                    <base-button nativeType="submit" type="primary" class="my-4">{{$t('save')}}</base-button>
                                </div>
                            </form>
                        </ValidationObserver>
                        </template>
                    </card>
                </div>
            </div>
        </div>
        <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>
    </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import i18n from "@/i18n"
  export default {
    name: 'addmember',
    components: {
        ValidationObserver
    },
    data() {
      return {
        id: this.$route.query.id,
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        form: {
          amount: '',
          type: 'monthly',
          note: ''
        }
      }
    },
    methods: {
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        onSubmit () {
            this.$http.post('members/'+this.id+'/payment', {
                "amount": this.form.amount,
                "type": this.form.type,
                "note": this.form.note
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/edit_member?id='+this.id)
        },
        onSubmitFailed (req) {
            this.modalAlert(req)
        }
    }
  };
</script>
<style></style>
